document.querySelectorAll('.AddAdvertForm').forEach((el) => {
    const validateEl = el.parentElement.querySelector('.AddAdvertForm__validate');
    const sections = el.querySelectorAll('section');

    sections.forEach((section) => {
        const div = document.createElement('div');
        div.innerText = section.querySelector('h2').innerText;
        div.addEventListener('click', () => {
            section.scrollIntoView({ behavior: "smooth"});
        })
        validateEl.append(div);

        const inputs = [...section.querySelectorAll('input, textarea')];
        inputs.forEach((input) => {
            input.addEventListener('input', () => {
                div.classList.toggle('active', inputs.every((input) => input.value));
            });
        })
    })

})
